<template>
  <!-- TODO: I18n -->
  <div class="view result-import-companies">
    <div v-if="result" class="content">
      <div v-if="result.importsHistories.items.length > 1" class="title">Rapport d'importation</div>
      <div v-if="result.importsHistories.items.length > 1" class="title-content">
        <div class="square">
          <div class="title-square">{{ result.totalCompaniesFail }}</div>
          <div class="info-square">entreprises rejetées</div>
        </div>
        <div class="square">
          <div class="title-square">{{ result.totalCompaniesArchived }}</div>
          <div class="info-square">entreprises archivées</div>
        </div>
        <div class="square">
          <div class="title-square">{{ result.totalCompaniesInactive }}</div>
          <div class="info-square">Entreprises inactives</div>
        </div>
        <div class="square">
          <div class="title-square">{{ result.totalCompaniesAdded }}</div>
          <div class="info-square">Entreprises ajoutés</div>
        </div>
        <div class="square">
          <div class="title-square">{{ result.totalCompaniesUpdated }}</div>
          <div class="info-square">surveillances actualisées</div>
        </div>
        <div class="square">
          <div class="title-square">{{ result.totalCompaniesPending }}</div>
          <div class="info-square">Entreprises en cours de traitement</div>
        </div>
      </div>

      <div v-if="result && result.importsHistories.items.length > 1" class="title-container fullSize">
        <div class="form-container">
          <div class="input-title">{{ $t('action') }}</div>
          <Dropdown
            class="monitoring"
            :config="{ inputSize: 48, active: false }"
            :values="[0, 1, 2, 3, 4, 5, 6, 10, 11, 12, 13, 14]"
            :placeholder="$t('action')"
            :on-change="value => (action = value)"
            :value="action"
          >
            <template #placeholder="{ value, isPlaceholder }">
              <ActionType v-if="!isPlaceholder" :company="{ actionType: value }" :config="{ style: 'filter', showWording: true }" />
              <div v-else class="value grey">{{ value }}</div>
            </template>
            <template #choices="{ choice }">
              <ActionType :company="{ actionType: choice }" :config="{ style: 'filter', showWording: true }" />
            </template>
          </Dropdown>
        </div>
        <div class="form-container search">
          <div class="input-title">{{ $t('research') }}</div>
          <input v-model="search" type="text" class="input search" :placeholder="$t('companiesSearch')" />
        </div>
        <div class="form-container">
          <div class="input-title">{{ $t('paginationNumberTitle') }}</div>
          <Dropdown
            class=""
            :config="{ inputSize: 48 }"
            :values="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
            :placeholder="$t('choosePaginationNumber')"
            :on-change="value => (paginationNumber = value)"
            :value="paginationNumber"
          >
            <template #placeholder="{ value }">
              <div class="value grey">{{ value }}</div>
            </template>
            <template #choices="{ choice }">
              <div class="value grey">{{ choice }}</div>
            </template>
          </Dropdown>
        </div>
      </div>

      <div class="title-container">
        <div class="title">Entreprises traitées ({{ result.totalCompanies }})</div>
        <div class="back-to-wallet" @click="$router.go(-1)">
          <div class="icon icon-arrow left" />
          Revenir à l'historique d'import
        </div>
      </div>

      <div v-if="result && result.importsHistories.items.length > 1" class="title-container">
        <div class="link-button reset-button" @click="resetFilters">{{ $t('resetFilters') }} <ResetIcon class="icon-reset" /></div>
      </div>

      <ImportTable
        :data="result.importsHistories"
        :config="{ pagination: result && result.importsHistories.items.length > 1 }"
        :filters="{ search, action, paginationNumber }"
      />
      <div v-if="result.totalCompaniesPending" class="info">
        <div class="icon"></div>
        <div class="text">Les alertes et documents des dossiers mis sous surveillance et actualisés seront enrengistrés dans le portail dès demain.</div>
      </div>
      <div v-if="result.totalCompaniesInactive" class="info">
        <div class="icon"></div>
        <div class="text">La mise sous surveillance d'entités non inscrites au RCS est inactive.</div>
      </div>
      <div class="info margin-bottom">
        <div class="icon"></div>
        <div class="text">La mise sous surveillance pour les agents commerciaux et entrepreneurs individuels est limitée aux documents disponibles.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ActionType from '@/components/actionType';
import Dropdown from '@/components/Dropdown';
import ImportTable from '@/components/tables/ImportTable';

export default {
  components: { ImportTable, Dropdown, ActionType },

  data() {
    return {
      loading: false,
      result: false,
      action: '',
      search: '',
      paginationNumber: 10,
    };
  },

  computed: {
    ...mapGetters(['isLogged', 'user']),
  },

  async mounted() {
    this.result = await this.$store.dispatch('getHistoryImportById', { id: this.$route.query.id });
  },

  methods: {
    resetFilters() {
      this.action = '';
      this.search = '';
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
* {
  box-sizing: border-box;
}

.reset-button {
  margin-top: 14px;
  box-sizing: content-box;
}

.view {
  padding: 170px 0 64px;
  box-sizing: border-box;
  color: colors.$black-color;
  .content {
    .title {
      font-weight: 500;
      font-size: 20px;
      color: colors.$darkblue-color;
      margin: 0 0 30px;
    }

    .title-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.fullSize {
        justify-content: flex-start;
      }

      .form-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        height: 100%;
        width: fit-content;

        .input-title {
          color: colors.$darkblue-color;
          font-weight: 500;
          font-size: 16px;
          margin: 46px 0 10px 0;
        }

        .input {
          width: 100%;
          height: 48px;
          margin: 0 0 16px;
          padding: 12px 16px;
          box-sizing: border-box;
          color: colors.$text-color;
          border: solid 1px colors.$lightgrey-color;
          border-radius: 4px;
          background: colors.$white-color;
          flex-grow: 1;

          &::placeholder {
            color: colors.$lightgrey-color;
          }
        }

        .monitoring {
          width: 250px;
          margin-right: 16px;
        }

        &.search {
          width: 40%;
          margin-right: 16px;
        }
      }

      .title {
        margin: 0;
      }

      .back-to-wallet {
        display: flex;
        align-items: center;
        color: colors.$lightblue-color;
        font-weight: 500;
        font-size: 14px;
        transition: all 0.2s;

        &:hover {
          opacity: 0.8;
          cursor: pointer;
        }
      }
    }

    .title-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0 0 80px;

      .square {
        color: colors.$lightblue-color;
        background: colors.$unread-table-color;
        width: calc(100% / 7);
        height: 110px;
        padding: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        min-width: 182px;
        margin: 0 11px 11px 0;

        &:last-child {
          margin-right: 0;
        }

        .title-square {
          font-weight: 500;
          font-size: 35px;
          margin: 0 0 8px;
        }

        .info-square {
          font-size: 14px;
          text-align: center;
        }
      }
    }

    .info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 12px 0 0 0;

      .icon {
        margin: 0 12px 0 0;
        position: relative;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid colors.$lightblue-color;
        flex-shrink: 0;

        &:after {
          position: absolute;
          content: '';
          bottom: 2px;
          left: calc(50% - 1px);
          right: calc(50% - 1px);
          height: 6px;
          background: colors.$lightblue-color;
        }

        &:before {
          position: absolute;
          content: '';
          top: 3px;
          left: calc(50% - 1px);
          right: calc(50% - 1px);
          height: 2px;
          background: colors.$lightblue-color;
        }
      }

      .text {
        color: colors.$lightblue-color;
        font-size: 14px;
        opacity: 0.8;
      }

      &.margin-bottom {
        margin-bottom: 24px;
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
}
</style>
